module.exports = __webpack_public_path__ + "img/private.0f3b0851.svg";